import React, { FC } from 'react';
import { SearchResultCommentary } from './SearchResultCommentary';
import { SearchCommentary } from './searchResultComment.types';
import { Connect, PropsFromRedux } from './SearchResultCommentariesContainer';
import { ItemSeparator } from '../../../../components/item-separator/ItemSeparator';
import styles from './search_result_commentaries.module.scss';

type Props = {
  commentaries: Array<SearchCommentary>;
} & PropsFromRedux;

export const RawSearchResultCommentaries: FC<Props> = ({
  commentaries,
  originalQueryKey,
  enableSnippets,
}) => {
  return (
    <>
      {commentaries.map((commentary) => (
        <div
          data-test-id="search-commentary-card"
          className={styles.commentaries}
          key={commentary.commentaireId}
        >
          <ItemSeparator />
          <SearchResultCommentary
            commentary={commentary}
            originalQueryKey={originalQueryKey || ''}
            enableSnippets={enableSnippets}
          />
        </div>
      ))}
    </>
  );
};

export const SearchResultCommentaries = Connect(RawSearchResultCommentaries);
